import { TaskFilters } from '@app/shared/types/models/task/task-filters.model';

const TASK_FILTER_DATE_FIELDS = [
  'startDateFrom',
  'startDateTo',
  'endDateFrom',
  'endDateTo',
  'createdDateFrom',
  'createdDateTo',
  'editDateFrom',
  'editDateTo'
] as const satisfies readonly (keyof TaskFilters)[];

/** Parses API or in-memory filter date values into `Date` instances. */
export function parseTaskFilterDate(value: Date | string | null | undefined): Date | null {
  if (value == null) {
    return null;
  }
  if (value instanceof Date) {
    return Number.isNaN(value.getTime()) ? null : value;
  }
  const parsed = new Date(value);
  return Number.isNaN(parsed.getTime()) ? null : parsed;
}

/** Returns millisecond timestamp for filter date comparison; null when unset or invalid. */
export function taskFilterDateTimestamp(value: Date | string | null | undefined): number | null {
  const date = parseTaskFilterDate(value);
  return date?.getTime() ?? null;
}

/** Normalizes date fields on task filters loaded from the API (JSON strings → `Date`). */
export function normalizeTaskFilters(filters: TaskFilters | null | undefined): TaskFilters | null {
  if (!filters) {
    return null;
  }

  const normalized: TaskFilters = { ...filters };

  for (const field of TASK_FILTER_DATE_FIELDS) {
    const parsed = parseTaskFilterDate(filters[field]);
    if (parsed == null) {
      delete normalized[field];
    } else {
      normalized[field] = parsed;
    }
  }

  return normalized;
}
